<template>
  <div>
    <!--生成应收时间-->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('receivablePayable.SelectGenerateAccrualTime')"
      :visible.sync="generateReceivables"
      width="500px"
    >
      <el-form
        ref="receivableForm"
        size="small"
        :model="receivableForm"
      >
        <el-form-item
          :label="$t('receivablePayable.SelectGenerateAccrualDate')"
          prop="timeCollection"
          :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
        >
          <el-date-picker
            v-model="receivableForm.timeCollection"
            :end-placeholder="$t('operationCenter.endDate')"
            :start-placeholder="$t('operationCenter.startDate')"
            range-separator="-"
            style="width: 100%"
            size="small"
            type="daterange"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item
          :label="$t('receivablePayable.billType')"
          prop="statementType"
          :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
        >
          <el-select
            v-model="receivableForm.statementType"
            :placeholder="$t('operationCenter.PleaseSelect')"
            clearable
            size="small"
            filterable
            style="width: 100%;"
          >
            <el-option
              v-for="item in EXPRESS_TYPE"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!--取 消-->
        <el-button size="small" @click="colsDialog">{{ $t('basicData.Cancel') }}</el-button>
        <!--确 定-->
        <el-button size="small" type="primary" @click="determineReceivables">{{ $t('basicData.determine') }}</el-button>
      </div>
    </el-dialog>

    <BatchNumberDialog
      ref="batchNumberRef"
      :batch-number="batchNumber"
    />
  </div>
</template>

<script>
import { EXPRESS_TYPE } from '../../utils';
import { checkSameMonth } from '@/views/finance/utils';
import { apiGenerateBillNumber } from '@/api/finance/receivables';
import { cloneDeep } from 'lodash-es';
export default {
  name: 'ReceivableDialog',

  components: {
    BatchNumberDialog: () => import('./batchNumberDialog.vue')
  },

  props: {
    // 选中数据
    selectData: {
      type: Array,
      default: () => []
    },
    // 查询条件
    queryForm: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      EXPRESS_TYPE,
      generateReceivables: false,
      receivableForm: {
        timeCollection: '',
        statementType: ''
      },
      batchNumber: []
    };
  },
  methods: {
    openDialog() {
      this.generateReceivables = true;
    },
    colsDialog() {
      this.generateReceivables = false;
      this.$refs.receivableForm.resetFields();
    },
    determineReceivables() {
      const ids = this.selectData.map(item => item.id);
      const params = cloneDeep(this.queryForm);
      this.$refs.receivableForm.validate((valid) => {
        if (valid) {
          if (this.receivableForm.timeCollection && this.receivableForm.timeCollection.length > 0) {
            const flag = checkSameMonth(this.receivableForm.timeCollection);
            // 检查是否同一年月
            if (!flag) {
              this.$message.warning(this.$t('receivablePayable.dateRangeSameMonthValidation'));
              return;
            }
            params.nameStartTime = this.receivableForm.timeCollection[0];
            params.nameEndTime = this.receivableForm.timeCollection[1];

            const tips = ids.length > 0
              ? this.$t('receivablePayable.AreYouSureGenerateReceivablesSelectedData') // 确定给选中数据生成应收？
              : this.$t('receivablePayable.UncheckedDataWillGenerateReceivablesAllDataQueried'); // '未勾选数据将会给查询到的所有数据都生成应收，确定生成应收？';
            this.$confirm(tips, this.$t('basicData.tips'), // '提示'
              {
                confirmButtonText: this.$t('basicData.determine'), // '确定',
                cancelButtonText: this.$t('basicData.Cancel'), // '取消',
                type: 'warning'
              }
            ).then(() => {
              apiGenerateBillNumber({
                ...params,
                statementType: this.receivableForm.statementType,
                ids: ids
              }).then(res => {
                if (res.code === 200) {
                  this.batchNumber = res.data; // 批次号
                  this.$refs.batchNumberRef.open();
                  // 关闭当前弹窗
                  this.colsDialog();

                  // 刷新列表
                  this.$emit('change');
                }
              }).catch(err => {
                console.error(err);
              });
            });
          }
        } else {
          console.log('error submit!!');
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
